export { mockBulkActionList, mockUserActionList } from './data-table-actions.mock'
export { mockUserColumnList } from './data-table-columns.mock'
export { mockFilterList, mockPagination } from './data-table-filters.mock'
export { generateMockUserList } from './data-table-generator.util'
export type { MockUser } from './data-table-mock.interface'
export { mockUserList } from './data-table-users.mock'

export const DEFAULT_PAGE_SIZE_OPTION_LIST = [25, 50, 100]

export const DEFAULT_PAGE_SIZE = 50
